import * as React from 'react';
export const coastcapitalSvg = React.forwardRef(function coastcapitalSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#228BE0',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        d: 'M5.19 25.079h2.88l.06-.04c2.28-1.63 5-2.49 7.85-2.49 2.86 0 5.58.86 7.86 2.49l.06.04h2.91l-.4-.37a15.38 15.38 0 0 0-10.42-3.99c-3.89 0-7.58 1.42-10.4 3.99m6.96-11.49c0 2 1.56 3.65 3.57 3.65 1.43 0 2.66-.86 3.22-2.13h2.6a6.06 6.06 0 0 1-5.82 4.7 6.11 6.11 0 0 1-6.05-6.22c0-3.54 2.73-6.3 6.05-6.3 2.86 0 5.23 2.1 5.85 4.88h-2.58a3.53 3.53 0 0 0-6.84 1.42z',
        fill: '#FFF',
      }),
    ),
  );
});
coastcapitalSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var coastcapital = {
  category: 'brand',
  colorable: false,
  name: 'coastcapital',
  svg: coastcapitalSvg,
};
